import { APIMethod, fetchData } from "@client";
import { DEFAULT_WORK_TYPE_COLOR } from "@utils";

export async function createCustomWorkTypeQuery(name, backgroundColor=DEFAULT_WORK_TYPE_COLOR) {
  const data = {
    name,
    backgroundColor,
    type: "development",
    textColor: "#000000",
    description: "",
  };
  const res = await fetchData("/tags", APIMethod.PUT, { data, mapRequestKeysToSnakeCase:false });
  return {
    ...data,
    removable: true,
    id: res.results.id,
    rateCardCategoryId: res.results.rateCardCategoryId,
    rateCardCategoryRoles: res.results.rateCardCategoryRoles?.map(r => ({
      id: r.id,
      roleName: r.name,
      salesRate: 0,
      costRate: 0
    })),
  };
}
